package org.mkui.color

actual class MkColorFactory {
    actual companion object {
        actual val instance = MkColorFactory()
    }

    actual val aliceBlue by lazy { colorOf(240u, 248u, 255u) }
    actual val antiqueWhite by lazy { colorOf(250u, 235u, 215u) }
    actual val aqua by lazy { colorOf(0u, 255u, 255u) }
    actual val aquamarine by lazy { colorOf(127u, 255u, 212u) }
    actual val azure by lazy { colorOf(240u, 255u, 255u) }
    actual val beige by lazy { colorOf(245u, 245u, 220u) }
    actual val bisque by lazy { colorOf(255u, 228u, 196u) }
    actual val black by lazy { colorOf(0u, 0u, 0u) }
    actual val blanchedAlmond by lazy { colorOf(255u, 235u, 205u) }
    actual val blue by lazy { colorOf(0u, 0u, 255u) }
    actual val blueViolet by lazy { colorOf(138u, 43u, 226u) }
    actual val brown by lazy { colorOf(165u, 42u, 42u) }
    actual val burlyWood by lazy { colorOf(222u, 184u, 135u) }
    actual val cadetBlue by lazy { colorOf(95u, 158u, 160u) }
    actual val chartreuse by lazy { colorOf(127u, 255u, 0u) }
    actual val chocolate by lazy { colorOf(210u, 105u, 30u) }
    actual val coral by lazy { colorOf(255u, 127u, 80u) }
    actual val cornflowerBlue by lazy { colorOf(100u, 149u, 237u) }
    actual val cornsilk by lazy { colorOf(255u, 248u, 220u) }
    actual val crimson by lazy { colorOf(220u, 20u, 60u) }
    actual val cyan by lazy { colorOf(0u, 255u, 255u) }
    actual val darkBlue by lazy { colorOf(0u, 0u, 139u) }
    actual val darkCyan by lazy { colorOf(0u, 139u, 139u) }
    actual val darkGoldenrod by lazy { colorOf(184u, 134u, 11u) }
    actual val darkGray by lazy { colorOf(169u, 169u, 169u) }
    actual val darkGreen by lazy { colorOf(0u, 100u, 0u) }
    actual val darkKhaki by lazy { colorOf(189u, 183u, 107u) }
    actual val darkMagenta by lazy { colorOf(139u, 0u, 139u) }
    actual val darkOliveGreen by lazy { colorOf(85u, 107u, 47u) }
    actual val darkOrange by lazy { colorOf(255u, 140u, 0u) }
    actual val darkOrchid by lazy { colorOf(153u, 50u, 204u) }
    actual val darkRed by lazy { colorOf(139u, 0u, 0u) }
    actual val darkSalmon by lazy { colorOf(233u, 150u, 122u) }
    actual val darkSeaGreen by lazy { colorOf(143u, 188u, 143u) }
    actual val darkSlateBlue by lazy { colorOf(72u, 61u, 139u) }
    actual val darkSlateGray by lazy { colorOf(47u, 79u, 79u) }
    actual val darkTurquoise by lazy { colorOf(0u, 206u, 209u) }
    actual val darkViolet by lazy { colorOf(148u, 0u, 211u) }
    actual val deepPink by lazy { colorOf(255u, 20u, 147u) }
    actual val deepSkyBlue by lazy { colorOf(0u, 191u, 255u) }
    actual val dimGray by lazy { colorOf(105u, 105u, 105u) }
    actual val dodgerBlue by lazy { colorOf(30u, 144u, 255u) }
    actual val firebrick by lazy { colorOf(178u, 34u, 34u) }
    actual val floralWhite by lazy { colorOf(255u, 250u, 240u) }
    actual val forestGreen by lazy { colorOf(34u, 139u, 34u) }
    actual val fuchsia by lazy { colorOf(255u, 0u, 255u) }
    actual val gainsboro by lazy { colorOf(220u, 220u, 220u) }
    actual val ghostWhite by lazy { colorOf(248u, 248u, 255u) }
    actual val gold by lazy { colorOf(255u, 215u, 0u) }
    actual val goldenrod by lazy { colorOf(218u, 165u, 32u) }
    actual val gray by lazy { colorOf(128u, 128u, 128u) }
    actual val green by lazy { colorOf(0u, 128u, 0u) }
    actual val greenYellow by lazy { colorOf(173u, 255u, 47u) }
    actual val honeydew by lazy { colorOf(240u, 255u, 240u) }
    actual val hotPink by lazy { colorOf(255u, 105u, 180u) }
    actual val indianRed by lazy { colorOf(205u, 92u, 92u) }
    actual val indigo by lazy { colorOf(75u, 0u, 130u) }
    actual val ivory by lazy { colorOf(255u, 255u, 240u) }
    actual val khaki by lazy { colorOf(240u, 230u, 140u) }
    actual val lavender by lazy { colorOf(230u, 230u, 250u) }
    actual val lavenderBlush by lazy { colorOf(255u, 240u, 245u) }
    actual val lawnGreen by lazy { colorOf(124u, 252u, 0u) }
    actual val lemonChiffon by lazy { colorOf(255u, 250u, 205u) }
    actual val lightBlue by lazy { colorOf(173u, 216u, 230u) }
    actual val lightCoral by lazy { colorOf(240u, 128u, 128u) }
    actual val lightCyan by lazy { colorOf(224u, 255u, 255u) }
    actual val lightGoldenrodYellow by lazy { colorOf(250u, 250u, 210u) }
    actual val lightGray by lazy { colorOf(211u, 211u, 211u) }
    actual val lightGreen by lazy { colorOf(144u, 238u, 144u) }
    actual val lightPink by lazy { colorOf(255u, 182u, 193u) }
    actual val lightSalmon by lazy { colorOf(255u, 160u, 122u) }
    actual val lightSeaGreen by lazy { colorOf(32u, 178u, 170u) }
    actual val lightSkyBlue by lazy { colorOf(135u, 206u, 250u) }
    actual val lightSlateGray by lazy { colorOf(119u, 136u, 153u) }
    actual val lightSteelBlue by lazy { colorOf(176u, 196u, 222u) }
    actual val lightYellow by lazy { colorOf(255u, 255u, 224u) }
    actual val lime by lazy { colorOf(0u, 255u, 0u) }
    actual val limeGreen by lazy { colorOf(50u, 205u, 50u) }
    actual val linen by lazy { colorOf(250u, 240u, 230u) }
    actual val magenta by lazy { colorOf(255u, 0u, 255u) }
    actual val maroon by lazy { colorOf(128u, 0u, 0u) }
    actual val mediumAquamarine by lazy { colorOf(102u, 205u, 170u) }
    actual val mediumBlue by lazy { colorOf(0u, 0u, 205u) }
    actual val mediumOrchid by lazy { colorOf(186u, 85u, 211u) }
    actual val mediumPurple by lazy { colorOf(147u, 112u, 219u) }
    actual val mediumSeaGreen by lazy { colorOf(60u, 179u, 113u) }
    actual val mediumSlateBlue by lazy { colorOf(123u, 104u, 238u) }
    actual val mediumSpringGreen by lazy { colorOf(0u, 250u, 154u) }
    actual val mediumTurquoise by lazy { colorOf(72u, 209u, 204u) }
    actual val mediumVioletRed by lazy { colorOf(199u, 21u, 133u) }
    actual val midnightBlue by lazy { colorOf(25u, 25u, 112u) }
    actual val mintCream by lazy { colorOf(245u, 255u, 250u) }
    actual val mistyRose by lazy { colorOf(255u, 228u, 225u) }
    actual val moccasin by lazy { colorOf(255u, 228u, 181u) }
    actual val navajoWhite by lazy { colorOf(255u, 222u, 173u) }
    actual val navy by lazy { colorOf(0u, 0u, 128u) }
    actual val oldLace by lazy { colorOf(253u, 245u, 230u) }
    actual val olive by lazy { colorOf(128u, 128u, 0u) }
    actual val oliveDrab by lazy { colorOf(107u, 142u, 35u) }
    actual val orange by lazy { colorOf(255u, 165u, 0u) }
    actual val orangeRed by lazy { colorOf(255u, 69u, 0u) }
    actual val orchid by lazy { colorOf(218u, 112u, 214u) }
    actual val paleGoldenrod by lazy { colorOf(238u, 232u, 170u) }
    actual val paleGreen by lazy { colorOf(152u, 251u, 152u) }
    actual val paleTurquoise by lazy { colorOf(175u, 238u, 238u) }
    actual val paleVioletRed by lazy { colorOf(219u, 112u, 147u) }
    actual val papayaWhip by lazy { colorOf(255u, 239u, 213u) }
    actual val peachPuff by lazy { colorOf(255u, 218u, 185u) }
    actual val peru by lazy { colorOf(205u, 133u, 63u) }
    actual val pink by lazy { colorOf(255u, 192u, 203u) }
    actual val plum by lazy { colorOf(221u, 160u, 221u) }
    actual val powderBlue by lazy { colorOf(176u, 224u, 230u) }
    actual val purple by lazy { colorOf(128u, 0u, 128u) }
    actual val rebeccaPurple by lazy { colorOf(102u, 51u, 153u) }
    actual val red by lazy { colorOf(255u, 0u, 0u) }
    actual val rosyBrown by lazy { colorOf(188u, 143u, 143u) }
    actual val royalBlue by lazy { colorOf(65u, 105u, 225u) }
    actual val saddleBrown by lazy { colorOf(139u, 69u, 19u) }
    actual val salmon by lazy { colorOf(250u, 128u, 114u) }
    actual val sandyBrown by lazy { colorOf(244u, 164u, 96u) }
    actual val seaGreen by lazy { colorOf(46u, 139u, 87u) }
    actual val seashell by lazy { colorOf(255u, 245u, 238u) }
    actual val sienna by lazy { colorOf(160u, 82u, 45u) }
    actual val silver by lazy { colorOf(192u, 192u, 192u) }
    actual val skyBlue by lazy { colorOf(135u, 206u, 235u) }
    actual val slateBlue by lazy { colorOf(106u, 90u, 205u) }
    actual val slateGray by lazy { colorOf(112u, 128u, 144u) }
    actual val snow by lazy { colorOf(255u, 250u, 250u) }
    actual val springGreen by lazy { colorOf(0u, 255u, 127u) }
    actual val steelBlue by lazy { colorOf(70u, 130u, 180u) }
    actual val tan by lazy { colorOf(210u, 180u, 140u) }
    actual val teal by lazy { colorOf(0u, 128u, 128u) }
    actual val thistle by lazy { colorOf(216u, 191u, 216u) }
    actual val tomato by lazy { colorOf(255u, 99u, 71u) }
    actual val turquoise by lazy { colorOf(64u, 224u, 208u) }
    actual val violet by lazy { colorOf(238u, 130u, 238u) }
    actual val wheat by lazy { colorOf(245u, 222u, 179u) }
    actual val white by lazy { colorOf(255u, 255u, 255u) }
    actual val whiteSmoke by lazy { colorOf(245u, 245u, 245u) }
    actual val yellow by lazy { colorOf(255u, 255u, 0u) }
    actual val yellowGreen by lazy { colorOf(154u, 205u, 50u) }
}